export default __webpack_public_path__ + "images/0f299123ebfd4c45aca399de8ca956ab.svg";